/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { PercentIcon, OneManDeliveryIcon, PoundIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './Propbar.styles';
var config = {
  argos: [{
    icon: /*#__PURE__*/React.createElement(PercentIcon, {
      width: 24,
      height: 24
    }),
    text: 'Black Friday',
    link: 'https://www.argos.co.uk/events/black-friday?tag=ar:propbar:black-Friday'
  }, {
    icon: /*#__PURE__*/React.createElement(OneManDeliveryIcon, {
      width: 24,
      height: 24
    }),
    text: 'Free delivery when you spend £100',
    link: 'https://help.argos.co.uk/help/delivery-&-collection-guide?tag=ar:propbar:sameandnext'
  }, {
    icon: /*#__PURE__*/React.createElement(PoundIcon, {
      width: 24,
      height: 24
    }),
    text: 'Flexible credit available',
    link: 'https://help.argos.co.uk/help/your-ways-to-pay?tag=ar:propbar:flexcredit'
  }],
  habitat: [{
    icon: /*#__PURE__*/React.createElement(PercentIcon, {
      width: 24,
      height: 24
    }),
    text: 'Black Friday',
    link: '/events/sale?tag=propbar:sale'
  }, {
    icon: /*#__PURE__*/React.createElement(OneManDeliveryIcon, {
      width: 24,
      height: 24
    }),
    text: 'Free delivery when you spend £100',
    link: '/help/delivery-collection-guide?tag=propbar:delivery'
  }, {
    icon: /*#__PURE__*/React.createElement(PoundIcon, {
      width: 24,
      height: 24
    }),
    text: 'Flexible credit available',
    link: '/help/argos-card?tag=propbar:argos-card'
  }]
};

var Propbar = function Propbar(_ref) {
  var brand = _ref.brand;
  var data = config[brand.toLowerCase()] || {};
  return Object.keys(data).length > 0 && /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test": "component-propbar"
  }, /*#__PURE__*/React.createElement(Styled.Wrapper, {
    brand: brand
  }, data.map(function (_ref2) {
    var icon = _ref2.icon,
        text = _ref2.text,
        link = _ref2.link;
    return text && /*#__PURE__*/React.createElement("li", {
      key: text,
      "data-test": "propbar-section"
    }, /*#__PURE__*/React.createElement(Styled.PropbarLink, {
      href: link,
      "data-test": "propbar-link"
    }, /*#__PURE__*/React.createElement(Styled.Icon, {
      "data-test": "propbar-icon"
    }, icon), text));
  })));
};

Propbar.defaultProps = {
  brand: 'argos'
};
Propbar.propTypes = {
  brand: PropTypes.string
};
export default Propbar;